import { render, staticRenderFns } from "./GameIntro.vue?vue&type=template&id=62de1a77"
import script from "./GameIntro.vue?vue&type=script&lang=js"
export * from "./GameIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports